import useId from '../utils/useId';
import * as React from 'react';
export const gcashSvg = React.forwardRef(function gcashSvgInner(props, ref) {
  const id_0 = useId();
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#007CFF',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement(
      'g',
      {
        clipPath: `url(#bi_gcash__a_${id_0})`,
      },
      /*#__PURE__*/ React.createElement('path', {
        d: 'M25.677 16.12a11.5 11.5 0 0 1-1.242 5.23 1.164 1.164 0 0 0 1.285 1.666 1.159 1.159 0 0 0 .776-.597 13.904 13.904 0 0 0 0-12.574 1.16 1.16 0 0 0-1.562-.499l-.089.052a1.164 1.164 0 0 0-.413 1.513 11.507 11.507 0 0 1 1.245 5.208Z',
        fill: '#51C1FF',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M21.923 16.12a7.776 7.776 0 0 1-.71 3.262 1.162 1.162 0 0 0 1.39 1.601 1.164 1.164 0 0 0 .728-.632 10.178 10.178 0 0 0 0-8.456 1.164 1.164 0 0 0-2.17.152c-.08.27-.06.56.058.816a7.776 7.776 0 0 1 .704 3.256Z',
        fill: '#51C1FF',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M14.119 23.92a7.804 7.804 0 1 1 4.765-13.983 1.16 1.16 0 0 0 1.867-.987 1.158 1.158 0 0 0-.448-.843 10.123 10.123 0 1 0 .016 16.014 1.143 1.143 0 0 0 .108-1.708l-.025-.025a1.144 1.144 0 0 0-1.506-.087 7.772 7.772 0 0 1-4.777 1.62Z',
        fill: '#002CB8',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M20.342 15.27a1.197 1.197 0 0 0-.844-.355h-5.56a1.2 1.2 0 1 0 0 2.4h4.184a4.172 4.172 0 1 1-1.773-4.745 1.202 1.202 0 0 0 1.771-.626 1.197 1.197 0 0 0-.484-1.404 6.626 6.626 0 0 0-4.93-.865 6.482 6.482 0 0 0-5.008 5.05 6.576 6.576 0 1 0 13.006 1.38 1.203 1.203 0 0 0-.362-.835Z',
        fill: '#fff',
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'clipPath',
        {
          id: `bi_gcash__a_${id_0}`,
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#fff',
          transform: 'translate(4 6)',
          d: 'M0 0h24v20.24H0z',
        }),
      ),
    ),
  );
});
gcashSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var gcash = {
  category: 'brand',
  colorable: false,
  name: 'gcash',
  svg: gcashSvg,
};
